import React, { useEffect } from 'react';
import { projects } from '../data';
import screens from '../screens';
import Arrow, { BackArrow } from './Arrow';
import ScreenReel from './ScreenReel';
import './ProjectPage.css';

export default function ProjectPage({ project }) {
  const index = projects.indexOf(project);
  const next = projects[(index + 1) % projects.length];
  const [kind, framework] = project.sub.split(' · ');

  useEffect(() => {
    const before = document.title;
    document.title = `${project.name} · Temitope Abodunrin`;
    return () => {
      document.title = before;
    };
  }, [project]);

  // Back to wherever the page was opened from on the site, or to the engineering list
  const back = e => {
    if (window.__siteNav) {
      e.preventDefault();
      window.history.back();
    }
  };

  return (
    <main className="case">
      <div className="shell">
        <div className="meta-row fade-in">
          <a className="meta case-back" href="#/engineer" onClick={back}><BackArrow /> Engineer</a>
          <span className="meta">{String(index + 1).padStart(2, '0')} / {kind}</span>
        </div>

        <h1 className="display case-title">
          <span className="mask"><span>{project.name}</span></span>
        </h1>

        <div className="case-bar fade-in" style={{ '--d': 2 }}>
          <div className="case-links">
            <a className="btn btn-solid" href={project.link} target="_blank" rel="noreferrer">Visit live site <Arrow /></a>
            {project.github && <a className="btn" href={project.github} target="_blank" rel="noreferrer">GitHub <Arrow /></a>}
          </div>
          <span className="meta case-live"><i className="dot" />Live</span>
        </div>
      </div>

      <div className="fade-in" style={{ '--d': 3 }}>
        <ScreenReel key={project.slug} screens={screens[project.slug]} name={project.name} />
      </div>

      <div className="shell case-body">
        <section className="rv">
          <p className="meta case-label">About the project</p>
          <p className="case-desc">{project.desc}</p>
        </section>

        <section className="rv">
          <p className="meta case-label">Spec</p>
          <dl className="case-spec">
            <div><dt className="meta">Discipline</dt><dd>{kind}</dd></div>
            <div><dt className="meta">Built with</dt><dd>{framework}</dd></div>
            <div><dt className="meta">State</dt><dd>Live</dd></div>
            <div><dt className="meta">Stack</dt><dd>{project.tags.join(' · ')}</dd></div>
          </dl>
        </section>

        <a className="case-next rv" href={`#/work/${next.slug}`}>
          <span className="meta">Next project</span>
          <span className="display">{next.name}</span>
          <Arrow />
        </a>
      </div>
    </main>
  );
}
